<div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
    <h1>{{'PROCESS_STATUS.'.concat(data.title) | translate}}</h1>
    <form [formGroup]="addNewOrderForm">
        <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Orden</mat-label>
            <input matInput formControlName="orden" type="text" value="{{data.row.orden}}">
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Colada</mat-label>
            <input matInput formControlName="colada" type="text" value="{{data.row.colada}}">
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Clave</mat-label>
            <input matInput formControlName="clave" type="text" value="{{data.row.clave}}">
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Bono</mat-label>
            <input matInput formControlName="bono" type="text" value="{{data.row.bono}}">
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Modelo</mat-label>
            <select matNativeControl formControlName="modelo">
                <option *ngFor="let m of maestrosModels" [value]="m.modelo" value="{{data.row.modelo.modelo}}">
                    {{m.modelo}}
                </option>
            </select>
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Horno</mat-label>
            <select matNativeControl formControlName="dispUUID">
                <option *ngFor="let d of dispositivosOptions" [value]="d.uuid" value="{{data.row.disp}}">
                    {{d.nombre}}
                </option>
            </select>
        </mat-form-field>
        <div *ngIf="userRole.includes('admin') || userRole.includes('orders-manager')">
            <mat-label>Inicio</mat-label>
            <mat-form-field appearance="fill" style="width: 100%;">
                <input matInput formControlName="inicio" [owlDateTime]="fromdatepicker"
                    value="{{data.row.inicio | getDatePipe}}"
                    placeholder="{{(data.row.inicio != null) ? (data.row.inicio | getDatePipe) : 'Introducir inicio...'}}">
                <owl-date-time #fromdatepicker>{{data.row.inicio}</owl-date-time>
                <span [owlDateTimeTrigger]="fromdatepicker" class="trigger">
                    <i class="fa fa-calendar"></i>
                </span>
            </mat-form-field>
            <mat-label>Finalización</mat-label>
            <mat-form-field appearance="fill" style="width: 100%;">
                <input matInput formControlName="fin" value="{{data.row.fin | getDatePipe}}"
                    [owlDateTime]="todatepicker"
                    placeholder="{{(data.row.fin != null) ? (data.row.fin | getDatePipe) : 'Introducir fin...'}}">
                <owl-date-time #todatepicker>{{data.row.fin}}</owl-date-time>
                <span [owlDateTimeTrigger]="todatepicker" class="trigger">
                    <i class="fa fa-calendar"></i>
                </span>
            </mat-form-field>

            <mat-form-field appearance="fill" style="width: 100%;">
                <mat-label>Estado</mat-label>
                <select matNativeControl formControlName="estado">
                    <option *ngFor="let st of status_options" [value]="st">
                        {{'PROCESS_STATUS.'.concat(st) | translate}}
                    </option>
                </select>
            </mat-form-field>
        </div>
    </form>

    <button mat-raised-button color="warn" mat-dialog-close (click)="onNoClick()">{{'CONFIRM_MODAL.NO' | translate
        }}</button>
    <button mat-raised-button color="primary" mat-dialog-close (click)="editOT()">{{'CONFIRM_MODAL.ACCEPT' | translate
        }}</button>
</div>